import React from 'react';
import { Card, CardBody, ModalBody } from 'shards-react';

interface ModalEditBodyDeleteProps {
  description: string;
  message: string;
}

const ModalEditBodyDelete = ({ description, message }: ModalEditBodyDeleteProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(isUniqueCode);
  // }, [isUniqueCode]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================
  return (
    <ModalBody>
      <Card theme="danger" className="mb-3">
        <CardBody className="text-white">
          <p>{description}</p>
        </CardBody>
      </Card>
      <p className="mb-0">{message}</p>
    </ModalBody>
  );
};

export default ModalEditBodyDelete;
